import { render, staticRenderFns } from "./AgeVerification.vue?vue&type=template&id=6b1cdbda&scoped=true&"
import script from "./AgeVerification.vue?vue&type=script&lang=ts&"
export * from "./AgeVerification.vue?vue&type=script&lang=ts&"
import style0 from "./AgeVerification.vue?vue&type=style&index=0&id=6b1cdbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1cdbda",
  null
  
)

export default component.exports